import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import LoanCashFlowListPageUI from './LoanCashFlowListPageUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class LoanCashFlowListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      cashFlowList: null,
      cashFlowDownloadRequested: false,
      cashFlowsUploadMode: false,
      successMsg: null,
    }
  }

  render() {
    return (
      <LoanCashFlowListPageUI
        context={this.props.context}
        loan={this.state.loan}
        cashFlowList={this.state.cashFlowList}
        errorList={this.toFloatingErrorList(this.state.errorList)}
        successMsg={this.state.successMsg}
        onRefreshClick={this.onRefreshClick}
        //
        cashFlowDownloadRequested={this.state.cashFlowDownloadRequested}
        onDownloadCashFlowTemplate={this.onDownloadCashFlowTemplate}
        //
        cashFlowsUploadMode={this.state.cashFlowsUploadMode}
        onCashFlowsUploadClick={() => { this.setState({ cashFlowsUploadMode: true }) }}
        onCashFlowsUploadCancel={() => { this.setState({ cashFlowsUploadMode: false }) }}
        cashFlowsSignedUrlApi={`/api/su/loans/${this.props.match.params.loanId}/cashFlows/fileUploadSignedUrl`}
        onCashFlowsUpload={this.onCashFlowsUpload}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getCashFlow(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      loan: response.loan,
    })
  }

  getCashFlow(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/cashFlows`,
      cacheKey: CacheKeys.LoanCashFlow(this.props.match.params.loanId),
      callback: this.getCashFlowCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getCashFlowCallback = (response) => {
    const reversedList = response.cashFlowList.reduce((acc, item) => [item].concat(acc), [])
    this.setState({ errorList: response.errorList, cashFlowList: reversedList })
  }

  onDownloadCashFlowTemplate = () => {
    let context = this.props.context
    this.setState({ cashFlowDownloadRequested: true })
    RestApiUtils.get(context, `/api/pub/contents/loan_file_upload_templates/loan_cashflow_template.xlsx`,
      this.onDownloadCashFlowTemplateCallback, null, null)
  }

  onDownloadCashFlowTemplateCallback = (response) => {
    this.setState({ cashFlowDownloadRequested: false })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.publicURL
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onCashFlowsUpload = (fileId, fileName, fileType, fileSize) => {
    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.match.params.loanId}/cashFlows/validation`,
      this.onCashFlowsUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onCashFlowsUploadCallback = (response) => {
    this.setState({
      successMsg: response.success,
      errorList: response.errorList,
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.onRefreshClick()
      }, 2000);
    }
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.LoanCashFlow(this.props.match.params.loanId))
    this.setState({ cashFlowList: null, errorList: null, successMsg: null },
      this.getCashFlow(this.props.context)
    )
  }

  toFloatingErrorList = (errorList) => {
    if (errorList == null) {
      return null
    }
    return errorList.flatMap((error) =>
      (error.message).split('\n').map((line) => ({ message: line.trim() })).filter((e) => e.message)
    )
  }
}

export default withRouter(LoanCashFlowListPageSF)